import jwt_decode from "jwt-decode";
import userImg from "../../Assets/user.svg";
import API from "../../api";

export const createAccount = async (name, email, password) => {
  try {
    await API.post("/auth/signup", {
      name,
      email,
      password,
    });

    const loginRes = await loginWithEmail(email, password);

    if (loginRes.error) {
      return { error: loginRes.error };
    }

    return loginRes;
  } catch (error) {
    return {
      error: error.response?.data?.message || error.message,
    };
  }
};

export const loginWithEmail = async (email, password) => {
  try {
    const res = await API.post("/auth/login", {
      email,
      password,
    });

    const data = res.data;

    localStorage.setItem("token", data.token);

    return {
      isSignedIn: true,
      name: data.user.name,
      email: data.user.email,
      img: userImg,
      role: data.user.role,
    };
  } catch (error) {
    return {
      error: error.response?.data?.message || error.message,
    };
  }
};

export const googleProvider = null;

export const loginWithProvider = async () => {
  return {
    error: "Google login is disabled for backend authentication right now",
  };
};

const defaultName = (str) => {
  let myStr = str || "";
  let firstWord = myStr.substring(0, 4);
  return firstWord;
};

export const getDecodedUser = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return {};
  }

  try {
    const decoded = jwt_decode(token);

    return {
      isSignedIn: true,
      name: decoded.name || defaultName(decoded.email),
      email: decoded.email,
      img: decoded.picture || userImg,
      role: decoded.role,
    };
  } catch (error) {
    localStorage.removeItem("token");
    return {};
  }
};

export const handleSignOut = () => {
  localStorage.removeItem("token");

  return {
    isSignedIn: false,
    name: "",
    email: "",
    img: "",
    role: "",
  };
};